/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RiDeleteBinLine } from 'react-icons/ri';
import { removeFromWishlist } from '../../../../../redux/slices/wishlistSlice';
import { BiRupee } from 'react-icons/bi';
import StarRatings from 'react-star-ratings';
import { getAverageRatingReview } from '../../../../../services/operations/courseApi';

const WishlistCard = ({ course }) => {
    const dispatch = useDispatch();
    const [avgRating, setAvgRating] = useState(0);
    useEffect(() => {
        dispatch(getAverageRatingReview(setAvgRating, course._id));
    }, [course]);

    return (
        <div className='flex items-center sm:flex-row flex-col gap-4 mb-12 border-b border-b-richblack-700 pb-4 sm:h-[12rem]'>
            <div className='sm:w-[35rem] h-full'>
                <img
                    src={course?.thumbnail}
                    alt={course?.courseName}
                    className='h-full w-full object-cover rounded-lg'
                    loading='lazy'
                />
            </div>
            <div className='flex flex-col h-full w-full'>
                <p className='text-lg py-3 sm:h-[5rem]'>
                    {course?.courseName}
                </p>
                <p className='text-sm text-richblack-200'>
                    {course?.category?.name}
                </p>
                <p className='text-sm text-richblack-200'>
                    By {course?.instructor?.firstName} {course?.instructor?.lastName}
                </p>
                <div className='flex items-center py-3'>
                    {avgRating > 0 &&
                        <span className='text-yellow-50 pr-2 pt-1'>
                            {avgRating.toFixed(1)}
                        </span>
                    }
                    <StarRatings
                        numberOfStars={5}
                        rating={avgRating}
                        starDimension={'20px'}
                        starSpacing={'1px'}
                        starRatedColor={'#FFD60A'}
                        starEmptyColor={'#6E727F'}
                    />
                    <span className='px-2 text-richblack-300 pt-1'>
                        {course?.ratingAndReviews?.length} rating(s)
                    </span>
                </div>
            </div>
            <div className='flex sm:flex-col flex-row gap-x-4 items-end space-y-2 h-full'>
                <button
                    className='flex items-center gap-x-1 rounded-md border-b-richblack-600 bg-richblack-700 py-3 px-[12px] text-pink-200'
                    onClick={() => dispatch(removeFromWishlist(course?._id))}
                >
                    <RiDeleteBinLine />
                    <span>Remove</span>
                </button>
                <p className='mb-6 text-3xl flex items-center font-medium text-yellow-100'>
                    <span><BiRupee /></span>
                    <span>{parseInt(course?.price).toLocaleString()}</span>
                </p>
            </div>
        </div>
    );
}

export default WishlistCard;